import { createFileRoute } from "@tanstack/react-router";

import { ContactFormSection } from "@/components/site/ContactForm";
import { PageHero } from "@/components/site/PageHero";
import { SiteFooter } from "@/components/site/SiteFooter";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact adaptED — Talk to our team" },
      {
        name: "description",
        content:
          "Get in touch with the adaptED team about our AI learning companion, school partnerships or the pilot programme.",
      },
      { property: "og:title", content: "Contact adaptED — Talk to our team" },
      {
        property: "og:description",
        content: "Send the adaptED team a message about learning, schools or partnerships.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://www.adapted.info/contact" },
      { property: "og:site_name", content: "adaptED" },
      { name: "twitter:title", content: "Contact adaptED — Talk to our team" },
      { name: "twitter:description", content: "Send the adaptED team a message about learning, schools or partnerships." },
    ],
    links: [{ rel: "canonical", href: "https://www.adapted.info/contact" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          url: "https://www.adapted.info/contact",
          name: "Contact adaptED",
          about: { "@id": "https://www.adapted.info/#organization" },
        }),
      },
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <main id="top">
      <PageHero
        label="Contact"
        title="Let's talk about learning"
        paragraph="Whether you're a learner, parent, teacher or partner, we'd love to hear from you."
      />
      <ContactFormSection />
      <SiteFooter />
    </main>
  );
}
